<template>
<div class="card">
    <h6>YOUR CURRENT ENERGY SUPPLY</h6>
   <h4>Do you have an Economy 7 meter?</h4>

   <div class="row">
       <div class="col-xs-6 col-sm-4 col-md-3">
          <radio-button
             v-model="quote.isEconomy7"
             :value="true"
             :error="$v.isEconomy7.$error">Yes</radio-button>
       </div>

       <div class="col-xs-6 col-sm-4 col-md-3">
          <radio-button
             v-model="quote.isEconomy7"
             :value="false"
             :error="$v.isEconomy7.$error">No</radio-button>
       </div>
   </div>
</div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import { mapState  } from 'vuex';

export default {
  name: 'Economy7',
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote
    })
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss">
</style>
